export function gtmEvent(props: {
  event: string;
  categoria: string;
  acao: string;
  rotulo: string;
  atendimento?: string;
}) {
  const { atendimento } = props;
  if (window.dataLayer)
    window.dataLayer.push({
      event: props.event,
      categoria: props.categoria,
      acao: props.acao,
      rotulo: props.rotulo,
      atendimento
    });
}
